import React, { useState } from "react";
import {
  getProvidersName,
  getGenderSpecialties,
  getAddress,
  getFormatedPhoneNumber,
  getEducations
} from "../../utils/find-providers";

const ProviderDetails = ({
  onBackButton,
  providerData,
  components,
  addFavoriteIcon,
  favoriteProviders = []
}) => {
  const [isFavorite, setFavorite] = useState(
    !!(favoriteProviders || []).find(
      provider => providerData.id === provider.data.id
    )
  );
  const { profile, practices, specialties, educations } = providerData;

  return (
    <>
      <button
        data-testid='button-back'
        type='button'
        className='button-left-arrow-web-sdk'
        onClick={onBackButton}
      >
        Back
      </button>
      <div className='provider-details-web-sdk'>
        {profile.imageUrl ? (
          <components.Image
            size={50}
            url={profile.imageUrl}
            omponents={components}
          />
        ) : (
          <div className='provider-details-profile-avatar' />
        )}

        <div className='websdk-ml-4 provider-details-info-web-sdk'>
          <div className='provider-info-block-web-sdk'>
            <div className=''>
              <components.Text
                label={getProvidersName(profile)}
                params='provider-name-header-web-sdk'
              />
              <div className='provider-specialties'>
                <components.Label text={getGenderSpecialties(specialties)} />
              </div>
            </div>
            {addFavoriteIcon(isFavorite, providerData, setFavorite)}
          </div>

          <div className='provider-info-block-web-sdk'>
            <components.Text
              label='Locations'
              params='provider-details-header-web-sdk'
            />
            <div className='provider-details-location-web-sdk'>
              <components.Label
                text={getAddress(practices[0].visitAddress)}
                params='provider-address-web-sdk websdk-text-base'
              />
              <components.Label
                text={`${practices[0].distance.toFixed(2)} mi`}
                params='provider-distance-web-sdk websdk-text-base'
              />
            </div>
            {practices[0].phones[0].number ? (
              <>
                <components.Label
                  text={getFormatedPhoneNumber(practices[0])}
                  params='provider-detail-phone-web-sdk'
                />
                <components.PhoneLink
                  label='Call'
                  link={practices[0].phones[0].number}
                />
              </>
            ) : null}
          </div>

          <div className='provider-info-block-web-sdk'>
            <components.Text
              label='About'
              params='provider-details-header-web-sdk'
            />
            {educations.filter(educ => educ.school !== null).length ? (
              <>
                <components.Label
                  text='School'
                  params='provider-sub-titles-web-sdk'
                />
                <components.Label
                  text={getEducations(
                    educations.filter(educ => educ.school !== null)
                  )}
                />
              </>
            ) : null}
            <components.Label
              text='Gender'
              params='provider-sub-titles-web-sdk websdk-mt-4'
            />
            <components.Label
              text={profile?.gender?.replace(
                /^./,
                profile?.gender[0].toUpperCase()
              )}
            />
          </div>
        </div>
      </div>
      <p className='provider-details-disclaimer-web-sdk'>
        Disclaimer: Please call individual providers to confirm they accept your
        health insurance. For a complete list of providers, please contact your
        health insurer. Provider information is provided by BetterDoctor.
      </p>
    </>
  );
};

export default ProviderDetails;
